"use strict";

export default function routes($stateProvider) {
  "ngInject";

  $stateProvider.state("operations", {
    url: "/operations",
    template: "<operations></operations>",
    authenticate: "hccadmin"
  });
}



// WEBPACK FOOTER //
// ./client/app/operations/operations.routes.js